<script setup>
defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2 class="text-xl font-semibold mb-3">
        Sobre as categorias de nota
      </h2>

      <p
        class="text-sm leading-relaxed text-gray-800 mb-3"
      >
        As categorias de nota agrupam os diferentes tipos de observações que
        você pode fazer sobre um texto. Cada categoria controla
        também o aspecto visual básico das marcações (cor, fundo e sublinhado).
      </p>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          Use esta página para criar categorias gerais, por exemplo:
          <strong>Compreensão</strong>, <strong>Expressão</strong>,
          <strong>Ortografia</strong>, <strong>Comentário do professor</strong>,
          etc.
        </li>
        <li>
          A coluna
          <strong>“Nota única palavra”</strong>
          mostra como a categoria aparece quando a nota está ligada a apenas
          uma palavra (chip colorido).
        </li>
        <li>
          A coluna
          <strong>“Nota várias palavras”</strong>
          mostra o estilo aplicado a trechos maiores, com foco na
          cor do sublinhado.
        </li>
        <li>
          As configurações visuais definidas aqui serão usadas em conjunto com
          os subtipos de nota para montar a paleta de destaques exibida no
          texto.
        </li>
        <li>
          Você pode selecionar várias categorias e usar
          <strong>Ações em lote</strong> para removê-las de uma só vez, quando
          necessário.
        </li>
      </ul>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>


